import {
  RECON_LOADED,
  RECON_LOADING,
  RECON_COMPANYLIST_LOADED,
  RECON_COMPANY_SELECTED,
  RECON_DETAILS_LOADED,
  RECON_SELECTED,
  RECON_UPLOADING_LOADED,
  RECON_UPLOADING_LOADING,
  RECON_UPLOAD_UPDATE,
  RECON_UPLOADING_FAILED,
  RECON_UPLOAD_CLEARED,
  INVOICE_LOADING,
  INVOICE_DETAILS_LOADED,
  INVOICE_DETAILS_LOADING_ERROR,
  RECON_RE_UPLOADING_FAILED,
  RECON_UPLOAD_INVOICE_UPDATE,
  ESS_RECON_COMPANYLIST_LOADED,
} from '../components/actions/reconciliationActions'

const initialState = {
  loading: true,
  companyList: null,
  essentialsCompanyList: null,
  selectedCompany: null,
  isEssentialsSelected: false,
  reconSelected: null,
  reconSelectedDetails: null,
  loadingCSV: [],
  loadingInvoice: false,
  loadedInvoice: null,
  loadingInvoiceError: null,
}

const reconReducer = (state = initialState, action) => {
  switch (action.type) {
    case RECON_LOADING:
      state.loading = true
      return state
    case RECON_LOADED:
      state.loading = false
      return state
    case RECON_COMPANYLIST_LOADED:
      state.companyList = action.payload
      return state
    case ESS_RECON_COMPANYLIST_LOADED:
      state.essentialsCompanyList = action.payload
      return state
    case RECON_COMPANY_SELECTED:
      state.selectedCompany = null
      if (state.companyList !== null) {
        state.selectedCompany = state.companyList.find((c) => c.id === action.payload)
        state.isEssentialsSelected = false
      }
      if (
        (state.selectedCompany === null || state.selectedCompany === undefined) &&
        state.essentialsCompanyList !== null
      ) {
        state.selectedCompany = state.essentialsCompanyList.find((c) => c.id === action.payload)
        state.isEssentialsSelected = true
      }
      return state
    case RECON_DETAILS_LOADED:
      state.reconSelectedDetails = action.payload
      state.loadingCSV = new Array(action.payload.reconciliationProducts.length).fill(false)
      return state
    case RECON_SELECTED:
      state.reconSelected = action.payload
      return state
    case RECON_UPLOADING_LOADED:
      state.loadingCSV[action.payload] = false
      return state
    case RECON_UPLOADING_LOADING:
      state.loadingCSV[action.payload] = true
      return state
    case RECON_UPLOAD_UPDATE:
      let index = state.reconSelectedDetails.reconciliationProducts.findIndex((p) => p.id === action.payload.productId)
      state.reconSelectedDetails.reconciliationProducts[index].users = action.payload.data
      state.reconSelectedDetails.reconciliationProducts[index].successMessage = true
      state.reconSelectedDetails.reconciliationProducts[index].clearMessage = false
      state.reconSelectedDetails.reconciliationProducts[index].errorMessage = false
      return state
    case RECON_UPLOAD_CLEARED:
      let indexCleared = state.reconSelectedDetails.reconciliationProducts.findIndex(
        (p) => p.id === action.payload.productId
      )
      state.reconSelectedDetails.reconciliationProducts[indexCleared].users = null
      state.reconSelectedDetails.reconciliationProducts[indexCleared].clearMessage = true
      state.reconSelectedDetails.reconciliationProducts[indexCleared].errorMessage = false
      state.reconSelectedDetails.reconciliationProducts[indexCleared].successMessage = false
      return state
    case RECON_UPLOADING_FAILED:
      let indexFailed = state.reconSelectedDetails.reconciliationProducts.findIndex(
        (p) => p.id === action.payload.productId
      )
      state.reconSelectedDetails.reconciliationProducts[indexFailed].errorMessage = true
      state.reconSelectedDetails.reconciliationProducts[indexFailed].successMessage = false
      state.reconSelectedDetails.reconciliationProducts[indexCleared].clearMessage = false
      state.loadingCSV[action.payload.index] = false
      return state
    case INVOICE_LOADING:
      state.loadingInvoice = true
      return state
    case INVOICE_DETAILS_LOADED:
      state.loadedInvoice = action.payload
      state.loadingInvoice = false
      return state
    case INVOICE_DETAILS_LOADING_ERROR:
      state.loadingInvoice = false
      state.loadingInvoiceError = action.payload
      return state
    case RECON_UPLOAD_INVOICE_UPDATE:
      let invoiceIndex = state.loadedInvoice.cwInvoiceProducts.findIndex(
        (p) => p.cW_Product_RecID === action.payload.cW_Product_RecID
      )
      state.loadedInvoice.cwInvoiceProducts[invoiceIndex].users = action.payload.data
      state.loadedInvoice.cwInvoiceProducts[invoiceIndex].successMessage = true
      state.loadedInvoice.cwInvoiceProducts[invoiceIndex].clearMessage = false
      state.loadedInvoice.cwInvoiceProducts[invoiceIndex].errorMessage = false
      return state
    case RECON_RE_UPLOADING_FAILED:
      let invoiceFailed = state.loadedInvoice.cwInvoiceProducts.findIndex(
        (p) => p.cW_Product_RecID === action.payload.cW_Product_RecID
      )
      state.loadedInvoice.cwInvoiceProducts[invoiceFailed].errorMessage = true
      state.loadedInvoice.cwInvoiceProducts[invoiceFailed].successMessage = false
      state.loadedInvoice.cwInvoiceProducts[invoiceFailed].clearMessage = false
      state.loadingCSV[action.payload.index] = false
      return state
    default:
      return state
  }
}

export default reconReducer
